import React from 'react';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { WorkerUpdateContent } from './WorkerUpdateContent';
import { PsPage } from '../../../../shared/components/ps-page/PsPage';
import { BreadcrumbsManagerInstance } from '../../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../../shared/breadcrumbs/Breadcrumbs';

export class WorkerUpdateScreen extends React.Component {

    constructor(props) {
        super(props);

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_CONTRACTORS,
            Breadcrumbs.MY_CONTRACTORS_WORKERS,
            Breadcrumbs.MY_CONTRACTORS_WORKERS_DETAIL,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MI_TRABAJADOR_PARA_MIS_CONTRATISTAS')} breadcrumbs={breadcrumbs}>
                <WorkerUpdateContent
                    id={Number(this.props.match.params.workerId)}
                    appendBreadcrumb={this.appendBreadcrumb}
                />
            </PsPage>
        );
    }

    appendBreadcrumb = (worker) => {
        BreadcrumbsManagerInstance.finishLoading({
            id: Breadcrumbs.MY_CONTRACTORS_WORKERS_DETAIL.id,
            url: this.props.location.pathname,
            description: worker.completeName(),
        });

        this.setState({
            breadcrumbs: [...BreadcrumbsManagerInstance.breadcrumbs()],
        });
    };

}

WorkerUpdateScreen.propTypes = {};

WorkerUpdateScreen.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/form/update/WorkerUpdateScreen.jsx